/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Plan_Tab_Seats_RemainingInputs */



/**
* | output |
* | --- |
* | "{count} seats remaining" |
*
* @param {Plan_Tab_Seats_RemainingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_tab_seats_remaining = /** @type {((inputs: Plan_Tab_Seats_RemainingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Tab_Seats_RemainingInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Plätze verfügbar`)
	return /** @type {LocalizedString} */ (`${i?.count} seats remaining`)
});